export const GET_ALL_ADDRESSES = "GET_ALL_ADDRESSES";
export const GET_ADDRESS_BY_ID = "GET_ADDRESS_BY_ID";
export const GET_ADDRESS_BY_CURRENCY_ID = "GET_ADDRESS_BY_CURRENCY_ID";
